import { render, staticRenderFns } from "./EditorsNote.vue?vue&type=template&id=6373e33a&scoped=true&"
import script from "./EditorsNote.vue?vue&type=script&lang=js&"
export * from "./EditorsNote.vue?vue&type=script&lang=js&"
import style0 from "./EditorsNote.vue?vue&type=style&index=0&id=6373e33a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373e33a",
  null
  
)

export default component.exports